import React from 'react';
import styled from 'styled-components';
import {FormattedMessage} from 'react-intl';
import {Field} from 'redux-form';
import {InputFieldWithValidation} from '../../../../../common/InputFieldWithValidation';
import DatePickerComponent from '../../../../../common/datePicker/DatePickerComponent';
import formMessages from '../../../../../../intl/afterSales/formMessages';
import {
    FORM_FIELD_INCIDENT_DATE,
    FORM_FIELD_MILEAGE_DECLARED_BY_OWNER,
    FORM_FIELD_MILEAGE_VERIFIED_BY_DEALER,
    FORM_FIELD_VIN,
    FORM_LABEL_INCIDENT_DATE,
    FORM_LABEL_MILEAGE_DECLARED_BY_OWNER,
    FORM_LABEL_MILEAGE_VERIFIED_BY_DEALER,
    FORM_LABEL_VIN,
} from '../../../../../../constants/formConstants';
import {
    required,
    notFutureDate,
    validDigitString,
    validMaxSevenCharLength,
    validVin,
} from '../../../../../common/validationCommons';
import * as moment from 'moment';

const StyledDiv = styled.div`
  border-radius: 5px;
`;

const VehicleDetailMaintenanceSection = (props) => {
    const {readOnly, reqFields, userRights} = props;
    // Only allow edit if explicitly permitted AND not readonly
    const canEditVehicleDetails = userRights && userRights.canEditInternalTicketVehDetails;
    const isFieldsDisabled = readOnly || !canEditVehicleDetails;

    const incidentDateValidations = [notFutureDate];
    if (reqFields.includes(FORM_FIELD_INCIDENT_DATE)) {
        incidentDateValidations.push(required);
    }

    return (
        <>
            <h3 className="text-left mt-4 ml-4">
                <FormattedMessage {...formMessages.VEHICLE_DETAIL_SECTION}/>
            </h3>
            <StyledDiv className="border border-secondary px-4 py-2 bg-white">
                <div className="form-row">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation
                            label={formMessages[FORM_LABEL_VIN]}
                            field={FORM_FIELD_VIN}
                            maxLength={17}
                            isDisabled={isFieldsDisabled}
                            isRequired={reqFields.includes(FORM_FIELD_VIN)}
                            validations={[validVin]}
                            isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 pb-2">
                        <Field
                            name={FORM_FIELD_INCIDENT_DATE}
                            component={DatePickerComponent}
                            label={formMessages[FORM_LABEL_INCIDENT_DATE]}
                            isRequired={reqFields.includes(FORM_FIELD_INCIDENT_DATE)}
                            isDisabled={isFieldsDisabled}
                            maxDate={new Date()}
                            parse={(value) => value ? moment(value).format('YYYY-MM-DD') : null}
                            validate={incidentDateValidations}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation
                            label={formMessages[FORM_LABEL_MILEAGE_DECLARED_BY_OWNER]}
                            field={FORM_FIELD_MILEAGE_DECLARED_BY_OWNER}
                            maxLength={7}
                            isDisabled={isFieldsDisabled}
                            validations={[validDigitString, validMaxSevenCharLength]}
                            isSmall
                        />
                    </div>
                    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 pb-2">
                        <InputFieldWithValidation
                            label={formMessages[FORM_LABEL_MILEAGE_VERIFIED_BY_DEALER]}
                            field={FORM_FIELD_MILEAGE_VERIFIED_BY_DEALER}
                            maxLength={7}
                            isDisabled={isFieldsDisabled}
                            validations={[validDigitString, validMaxSevenCharLength]}
                            isRequired={reqFields.includes(FORM_FIELD_MILEAGE_VERIFIED_BY_DEALER)}
                            isSmall
                        />
                    </div>
                </div>
            </StyledDiv>
        </>
    );
};

export default VehicleDetailMaintenanceSection;
